import React from "react";

interface SubMenuCellProps {
  onClick: () => void; // This is a function that returns nothing
  key: string; // Unique key for each cell
  label: string; // Display text for the cell
  icon: JSX.Element; // Prop for the icon
  className?: string; // Optional className prop
}

const SubMenuCell: React.FC<SubMenuCellProps> = ({
  onClick,
  key,
  label,
  icon,
  className,
}) => {
  // Use the provided className or fall back to default classes
  const classes =
    className || "flex cursor-pointer items-center gap-2 bg-status-good";

  return (
    <a className={classes} onClick={onClick} key={key}>
      {icon}
      {label}
    </a>
  );
};

export default SubMenuCell;
